import LinkCategoryFormConfig from "./form";
import GenericForm from "../GenericForm";
import { LinkCategoryApi, LinkCategoryDataType } from "@/api/LinkCategoryApi";
import { LinkCategoryFormData } from "@/formTypes/LinkCategoryFormDataType";

type LinkCategoryFormProps = {
    id?: string;
    formId: string;
    saveRedirectUrl?: string;
    defaultData?: LinkCategoryDataType;
    onStored?: (data?: LinkCategoryDataType) => void;
};

const LinkCategoryForm = (props: LinkCategoryFormProps) => {
    const { id, formId, saveRedirectUrl, defaultData, onStored } = props;

    return (
        <GenericForm<LinkCategoryFormData, LinkCategoryDataType>
            id={id}
            formId={formId}
            saveRedirectUrl={saveRedirectUrl}
            defaultData={defaultData}
            onStored={onStored}
            formConfig={LinkCategoryFormConfig}
            getById={(...args) => LinkCategoryApi.get(...args)}
            createFn={(...args) => LinkCategoryApi.create(...args)}
            updateFn={(...args) => LinkCategoryApi.update(...args)}
            successMessage="La categoría ha sido almacenada correctamente"
            errorMessage="No fue posible almacenar la categoría"
        />
    );
};

export default LinkCategoryForm;
